import { AppInsightsConnector as Connector } from '@faro/app-insights';
import { ReactNode } from 'react';
import { useSystemConfigQuery } from '../../query';

// Application Insights cloud role name for this app. Namespaced under `study-designer` to group
// with the backend services (e.g. `study-designer.faro-api`) so the Study Designer UI shows up
// under its own role in Application Insights instead of the shared "unknown role" catch-all.
const CLOUD_ROLE = 'study-designer.faro-ui';

export const AppInsightsConnector = (): ReactNode | null => {
    const { data: systemConfig } = useSystemConfigQuery();

    if (!systemConfig || !systemConfig.appInsightsClientConfig) {
        return null;
    }

    return (
        <Connector
            enabled={systemConfig.appInsightsClientConfig.enabled}
            clientConfig={{
                connectionString: systemConfig.appInsightsClientConfig.connectionString,
                cloudRole: CLOUD_ROLE,
            }}
        />
    );
};
